//语言下拉菜单-
$(function(){
    $(".lang-now").click(function () {
        $(this).siblings(".lang-menu").slideToggle();
    });
})